import type { VerseRef, VerseRange } from './bible';
import type { TagId } from './tags';

export interface Favourite {
  id: string;
  ref: VerseRef | VerseRange;
  createdAt: number;
  note?: string;
}

export interface Note {
  id: string;
  ref: VerseRef | VerseRange;
  body: string;
  createdAt: number;
  updatedAt: number;
  tags?: TagId[];
}

export interface StudySession {
  id: string;
  title: string;
  createdAt: number;
  updatedAt: number;
  closedAt?: number;
  verses: VerseRef[];
  notes: string;
}

export interface ReadingPlanProgress {
  planId: string;
  startedAt: number;
  completedDays: number[];
  lastReadAt: number;
}

export interface UserPreferences {
  id: 'singleton';
  theme: 'light' | 'dark' | 'night' | 'auto';
  nightIntensity: 'normal' | 'deep';
  fontFamily: 'literata' | 'inter' | 'system-serif' | 'system-sans' | 'opendyslexic';
  fontScale: number;
  lineHeight: number;
  measureCh: number;
  verseLayout: 'inline' | 'per-line';
  showVerseNumbers: boolean;
  redLetter: boolean;
  dropCaps: boolean;
  subscribedTags: TagId[];
  pushEnabled: boolean;
  pushHourLocal: number;
  autoThemeStartNight: number;
  autoThemeEndNight: number;
  reduceMotion: boolean;
  installedDismissedAt?: number;
  lastReadBook?: string;
  lastReadChapter?: number;
}

export const DEFAULT_PREFERENCES: UserPreferences = {
  id: 'singleton',
  theme: 'auto',
  nightIntensity: 'normal',
  fontFamily: 'literata',
  fontScale: 1,
  lineHeight: 1.7,
  measureCh: 68,
  verseLayout: 'inline',
  showVerseNumbers: true,
  redLetter: true,
  dropCaps: false,
  subscribedTags: [],
  pushEnabled: false,
  pushHourLocal: 7,
  autoThemeStartNight: 20,
  autoThemeEndNight: 6,
  reduceMotion: false,
};

export interface ActiveSessionMarker {
  id: 'active';
  sessionId: string | null;
}

export interface MeetingsFlag {
  id: 'singleton';
  notifyOnShip: boolean;
}
